module.exports = __webpack_public_path__ + "img/022-023.5f9177c2.jpg";